// extracted by mini-css-extract-plugin
export default {"btn":"SidebarBtn_btn__FULgt","activeBtn":"SidebarBtn_activeBtn__kTEnM"};